// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"56":"71ba6a6b","242":"cec3231a","397":"0f70650a","409":"76e08f4a","533":"4e4e2343","624":"261a5e88","642":"7df49a84","687":"9d151aa1","717":"d3de04f9","895":"bc75793d","947":"9bfcbc2b","949":"f050fd17"}[chunkId] + ".chunk.js";
};